import React from 'react';
export function TrustBar() {
  const metrics = [{
    label: 'Turnaround',
    value: '48h'
  }, {
    label: 'Varianten',
    value: 'Unlimited'
  }, {
    label: 'Qualität',
    value: 'Exposé-ready'
  }];
  return <section className="py-12 border-y border-white/5 bg-[#0A0A0B]" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-170">
          {/* Logos */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-8 opacity-40 hover:opacity-60 transition-all duration-500" data-id="element-171">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="h-8 w-32 bg-white/5 border border-white/10 rounded flex items-center justify-center" data-id="element-172">
                <span className="text-xs font-medium text-zinc-500 uppercase tracking-widest" data-id="element-173">
                  Kunde {i}
                </span>
              </div>)}
          </div>

          {/* Metrics */}
          <div className="flex items-center gap-8 sm:gap-12" data-id="element-174">
            {metrics.map(metric => <div key={metric.label} className="text-center lg:text-right" data-id="element-175">
                <p className="text-2xl sm:text-3xl font-semibold text-white" data-id="element-176">
                  {metric.value}
                </p>
                <p className="text-xs sm:text-sm font-light text-zinc-500 uppercase tracking-wide mt-1" data-id="element-177">
                  {metric.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}